module.exports = __webpack_public_path__ + "static/media/volume-mute.ac252e52.svg";